module.exports = __webpack_public_path__ + "media/components/shared/images/SpinGray-b599c320245699b243ffb970fc6fee11.svg";